/* currency-converter.js - shows prices in the visitor's own currency using live exchange rates (display only; checkout stays in the store currency) */
(function () {
  var KEY_CUR = 'cc_cur';
  var KEY_RATES = 'cc_rates';
  var KEY_CTRY = 'cc_country';
  var MAP = {};
  ('AE:AED,AF:AFN,AL:ALL,AM:AMD,AO:AOA,AR:ARS,AT:EUR,AU:AUD,AZ:AZN,BA:BAM,BB:BBD,BD:BDT,BE:EUR,BG:BGN,BH:BHD,BN:BND,BO:BOB,BR:BRL,BS:BSD,BW:BWP,BY:BYN,BZ:BZD,CA:CAD,CH:CHF,CL:CLP,CN:CNY,CO:COP,CR:CRC,CY:EUR,CZ:CZK,DE:EUR,DK:DKK,DO:DOP,DZ:DZD,EC:USD,EE:EUR,EG:EGP,ES:EUR,ET:ETB,FI:EUR,FJ:FJD,FR:EUR,GB:GBP,GE:GEL,GH:GHS,GR:EUR,GT:GTQ,HK:HKD,HN:HNL,HR:EUR,HU:HUF,ID:IDR,IE:EUR,IL:ILS,IN:INR,IQ:IQD,IS:ISK,IT:EUR,JM:JMD,JO:JOD,JP:JPY,KE:KES,KG:KGS,KH:KHR,KR:KRW,KW:KWD,KZ:KZT,LB:LBP,LK:LKR,LT:EUR,LU:EUR,LV:EUR,LY:LYD,MA:MAD,MD:MDL,MM:MMK,MN:MNT,MT:EUR,MU:MUR,MV:MVR,MX:MXN,MY:MYR,NG:NGN,NL:EUR,NO:NOK,NP:NPR,NZ:NZD,OM:OMR,PA:USD,PE:PEN,PH:PHP,PK:PKR,PL:PLN,PT:EUR,PY:PYG,QA:QAR,RO:RON,RS:RSD,RU:RUB,RW:RWF,SA:SAR,SE:SEK,SG:SGD,SI:EUR,SK:EUR,TH:THB,TN:TND,TR:TRY,TT:TTD,TW:TWD,TZ:TZS,UA:UAH,UG:UGX,US:USD,UY:UYU,UZ:UZS,VN:VND,ZA:ZAR,ZM:ZMW').split(',').forEach(function (p) {
    var a = p.split(':');
    MAP[a[0]] = a[1];
  });
  var cfg = null;
  var rates = null;
  var sym = '';
  var current = '';
  var rate = 1;
  var converted = [];
  var observer = null;
  var timer = null;
  var pending = [];
  var pick = null;
  var NBSP = String.fromCharCode(160);
  var APPROX = String.fromCharCode(8776);
  function T() { return window.theme || {}; }
  function store(k, v, sess) {
    var s = sess ? window.sessionStorage : window.localStorage;
    try {
      if (v === undefined) return s.getItem(k);
      s.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function readCfg() {
    var el = document.getElementById('currency-converter-cfg');
    if (!el || el.getAttribute('data-enable') !== 'true') return null;
    return {
      el: el,
      base: el.getAttribute('data-base') || 'GBP',
      auto: el.getAttribute('data-auto') === 'true',
      list: (el.getAttribute('data-list') || '').split(',').map(function (x) { return x.trim().toUpperCase(); }).filter(Boolean),
      approx: el.getAttribute('data-approx') === 'true',
      orig: el.getAttribute('data-orig') === 'true',
      whole: el.getAttribute('data-whole') === 'true',
      picker: el.getAttribute('data-picker') === 'true',
      pos: el.getAttribute('data-pos') || 'bl',
      ox: el.getAttribute('data-ox') || '16',
      oy: el.getAttribute('data-oy') || '16',
      size: el.getAttribute('data-size') || 'medium',
      bg: el.getAttribute('data-bg') || '#ffffff',
      fg: el.getAttribute('data-fg') || '#111111',
      note: el.getAttribute('data-note') || ''
    };
  }
  function lang() { return document.documentElement.lang || 'en'; }
  function baseSymbol() {
    var s = (T().moneyFormat || '').split('{{')[0].trim();
    if (s) return s;
    try {
      var parts = new Intl.NumberFormat(lang(), { style: 'currency', currency: cfg.base }).formatToParts(1);
      for (var i = 0; i < parts.length; i++) { if (parts[i].type === 'currency') return parts[i].value; }
    } catch (e) {}
    return '';
  }
  function lookup(url, pickFn) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, 3000);
    return fetch(url, ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(pickFn)
      .finally(function () { clearTimeout(t); });
  }
  function localeRegion() {
    var l = (navigator.language || '').split('-');
    return l.length > 1 ? l[1].toUpperCase() : '';
  }
  function detectCountry(cb) {
    var saved = store(KEY_CTRY, undefined, true);
    if (saved) { cb(saved); return; }
    lookup('https://api.country.is', function (d) { return d && d.country; })
      .catch(function () { return lookup('https://ipapi.co/json/', function (d) { return d && d.country_code; }); })
      .then(function (c) {
        c = c ? String(c).toUpperCase() : '';
        if (c) store(KEY_CTRY, c, true);
        cb(c || localeRegion());
      })
      .catch(function () { cb(localeRegion()); });
  }
  function loadRates(cb) {
    var cached = null;
    try { cached = JSON.parse(store(KEY_RATES) || 'null'); } catch (e) {}
    if (cached && cached.base === cfg.base && cached.rates && (Date.now() - cached.t) < 43200000) { cb(cached.rates); return; }
    fetch('https://open.er-api.com/v6/latest/' + cfg.base)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.rates) {
          store(KEY_RATES, JSON.stringify({ t: Date.now(), base: cfg.base, rates: d.rates }));
          cb(d.rates);
        } else { cb(cached && cached.rates ? cached.rates : null); }
      })
      .catch(function () { cb(cached && cached.rates ? cached.rates : null); });
  }
  function fmt(v) {
    var digits = (cfg.whole && v >= 100) ? 0 : 2;
    try {
      return new Intl.NumberFormat(lang(), { style: 'currency', currency: current, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v);
    } catch (e) { return current + ' ' + v.toFixed(digits); }
  }
  function isNum(c) { return '0123456789,.'.indexOf(c) > -1; }
  function convertText(s) {
    var out = '';
    var i = 0;
    while (i < s.length) {
      var at = s.indexOf(sym, i);
      if (at < 0) { out += s.slice(i); break; }
      out += s.slice(i, at);
      var j = at + sym.length;
      if (s.charAt(j) === ' ' || s.charAt(j) === NBSP) j++;
      var k = j;
      while (k < s.length && isNum(s.charAt(k))) k++;
      var numStr = s.slice(j, k);
      while (numStr && (numStr.slice(-1) === ',' || numStr.slice(-1) === '.')) { numStr = numStr.slice(0, -1); k--; }
      var val = parseFloat(numStr.split(',').join(''));
      if (!numStr || isNaN(val)) { out += s.slice(at, at + sym.length); i = at + sym.length; continue; }
      var piece = (cfg.approx ? APPROX + ' ' : '') + fmt(val * rate);
      if (cfg.orig) piece += ' (' + s.slice(at, k) + ')';
      out += piece;
      i = k;
    }
    return out;
  }
  function convertNode(n) {
    var s = n.nodeValue;
    if (!s || n.__ccOut === s || s.indexOf(sym) < 0) return;
    var out = convertText(s);
    if (out !== s) {
      n.__ccOrig = s;
      n.__ccOut = out;
      n.nodeValue = out;
      converted.push(n);
    }
  }
  function skipped(el) { return !!(el && el.closest && el.closest('[data-cc-skip],script,style,textarea,noscript')); }
  function walk(root) {
    if (root.nodeType === 1 && skipped(root)) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var list = [];
    var n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) {
      var p = t.parentNode;
      if (p && p.nodeType === 1 && skipped(p)) return;
      convertNode(t);
    });
  }
  function restoreAll() {
    converted.forEach(function (n) {
      if (n.__ccOut === n.nodeValue && n.__ccOrig != null) n.nodeValue = n.__ccOrig;
      n.__ccOut = null;
    });
    converted = [];
  }
  function observe() {
    if (!window.MutationObserver || !document.body) return;
    if (!observer) {
      observer = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.type === 'characterData') pending.push(m.target);
          else { [].slice.call(m.addedNodes).forEach(function (n) { pending.push(n); }); }
        });
        clearTimeout(timer);
        timer = setTimeout(flush, 80);
      });
    }
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  function mutate(fn) {
    if (observer) observer.disconnect();
    try { fn(); } finally { observe(); }
  }
  function flush() {
    var list = pending;
    pending = [];
    if (current === cfg.base || !rate) return;
    mutate(function () {
      list.forEach(function (n) {
        if (n.nodeType === 3) { if (!skipped(n.parentNode)) convertNode(n); }
        else if (n.nodeType === 1) walk(n);
      });
    });
  }
  function setCurrency(code, persist) {
    current = code;
    rate = (code !== cfg.base && rates && rates[code]) ? rates[code] : 1;
    if (persist) store(KEY_CUR, code);
    mutate(function () {
      restoreAll();
      if (code !== cfg.base && rate !== 1) walk(document.body);
    });
    updatePicker();
  }
  function nameOf(code) {
    try { return new Intl.DisplayNames([lang()], { type: 'currency' }).of(code) || ''; } catch (e) { return ''; }
  }
  function buildPicker() {
    if (!cfg.picker || pick) return;
    var codes = [cfg.base];
    cfg.list.concat([current]).forEach(function (c) { if (c && codes.indexOf(c) < 0 && rates[c]) codes.push(c); });
    pick = document.createElement('div');
    pick.className = 'cc-pick cc-pick--' + cfg.pos + ' cc-pick--' + cfg.size;
    pick.setAttribute('data-cc-skip', '');
    pick.style.cssText = '--cc-x:' + cfg.ox + 'px;--cc-y:' + cfg.oy + 'px;--cc-bg:' + cfg.bg + ';--cc-fg:' + cfg.fg;
    var items = codes.map(function (c) {
      return `<li><button type='button' class='cc-pick__item' data-cc-code='${c}'><b>${c}</b><small>${nameOf(c)}</small></button></li>`;
    }).join('');
    pick.innerHTML = `<button type='button' class='cc-pick__btn' aria-haspopup='true' aria-expanded='false'><svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round' aria-hidden='true'><circle cx='12' cy='12' r='9'/><path d='M3 12h18M12 3c3 3.2 3 14.8 0 18M12 3c-3 3.2-3 14.8 0 18'/></svg><span data-cc-label></span></button><div class='cc-pick__menu' hidden><p class='cc-pick__note'></p><ul class='cc-pick__list'>${items}</ul><p class='cc-pick__credit'><a href='https://www.exchangerate-api.com' target='_blank' rel='noopener'>Rates by Exchange Rate API</a></p></div>`;
    pick.querySelector('.cc-pick__note').textContent = cfg.note;
    var btn = pick.querySelector('.cc-pick__btn');
    var menu = pick.querySelector('.cc-pick__menu');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      menu.hidden = !menu.hidden;
      btn.setAttribute('aria-expanded', menu.hidden ? 'false' : 'true');
    });
    menu.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-cc-code]') : null;
      if (!b) return;
      setCurrency(b.getAttribute('data-cc-code'), true);
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('click', function (e) { if (!pick.contains(e.target)) menu.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu.hidden = true; });
    document.body.appendChild(pick);
    updatePicker();
  }
  function updatePicker() {
    if (!pick) return;
    var label = pick.querySelector('[data-cc-label]');
    if (label) label.textContent = current;
    [].slice.call(pick.querySelectorAll('[data-cc-code]')).forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-cc-code') === current);
    });
  }
  function start() {
    if (pick && pick.parentNode) pick.parentNode.removeChild(pick);
    pick = null;
    cfg = readCfg();
    if (!cfg) return;
    if (T().currency && T().shopCurrency && T().currency !== T().shopCurrency) return;
    sym = baseSymbol();
    if (!sym) return;
    loadRates(function (r) {
      if (!r) return;
      rates = r;
      function go(code) {
        if (code !== cfg.base && !rates[code]) code = cfg.base;
        setCurrency(code, false);
        buildPicker();
      }
      var chosen = store(KEY_CUR);
      if (chosen) { go(chosen); return; }
      if (!cfg.auto) { go(cfg.base); return; }
      detectCountry(function (c) { go(MAP[c] || cfg.base); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
